
export const isValidEmail = (t: string | null): boolean => {
  if (t == null) return false
  // eslint-disable-next-line no-useless-escape
  let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
  return reg.test(t)
}

export const isValidUrl = (t: string | null): boolean => {
  if (t == null) return false
  // eslint-disable-next-line no-useless-escape
  let reg = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/
  return reg.test(t)
}